// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__MvR+d","container":"Footer_container__tyfO0"};